import Sidebar from '../components/Sidebar';

const Training = () => {
  return (
    <div className="page-container fade-in">
      <div className="page-header-bg">
        <div className="page-hero-box">
          <h1>Nos Formations</h1>
          <div className="breadcrumbs">Accueil &gt; Nos Formations</div>
        </div>
      </div>

      <div className="container page-layout-grid">
        <div className="page-content-wrapper">
          <p><strong>Formation métier de freelance</strong></p>
          <p>
            Travailler à domicile peut être un choix de vie ou un moyen de compléter ses revenus. Pour de plus en plus d'Africain, travailler chez soi est devenu une réalité, avec de nombreux avantages. Il suffit juste d'avoir une bonne connexion web et un ordinateur. Il existe de nombreuses propositions de travail à domicile permettent d'avoir un job pour arrondir ses fins de mois. Les informations et formations que nous mettons à votre disposition vont aiderons à devenir autonome financièrement.
          </p>
          <p>
            Alors, comment travailler de chez soi sur Internet en 2020? Nous vous invitons à visiter régulièrement notre blog. Les très nombreuses propositions que nous publions vous aideront à trouver un petit boulot pour constituer un complément de revenus, la plupart du temps sans investissement nécessaire.
          </p>
          <p><strong>Formation sur les métiers du numérique</strong></p>
          <p>
            Nous avons de l'expérience sur les métiers du numérique. (Le motion design L'infopreneuriat, le Blogging, le métier de YouTube, le Marketing Digital, Community management, le Social Media Management, l'entrepreneuriat web, la création de start up.) Maîtriser l'art d'influencer le monde avec son smartphone a changer l'existence de nombreuse personne et pourquoi pas vous. Aujourd'hui devenir libre financièrement n'est plus un luxe mais une obligation. Car aujourd'hui grâce au numérique vous pouvez tout apprendre grâce au multiple tutoriel qu'il y a en ligne.
          </p>
          <p>
            De nos jours, c'est une aberration de dire je ne sais rien faire, vous pouvez améliorer votre passion en ligne et ceux presque gratuitement. Les prochaines années risqueraient d'être super difficile pour les personnes incapables de s'adapter aux nouvelles technologies. Seul ceux qui sauront s'adapter et se former pour bénéficier de nombreuse opportunité que nous offres le numérique pourrons se protéger et protéger leur famille.
          </p>
          <p>
            Mais vous savez dans la quête de la réussite financière en ligne il y a beaucoup de piège beaucoup de difficultés et seul les mieux préparer pourrons les éviter. Les développeurs, designers web, marketeurs, les social média manager, les community manager vont vous facturer des commissions indécentes pour un simple service peu performant, de nombreux infopreneurs vont vous promettre de devenir riche si vous suivez leur formation, d'autres vont vous demandez d'apprendre le trading et le outsourcing et de tous mise là dedans.
          </p>
          <p>
            Croyez moi il est très difficile de s'en sortir dans cette jungle rien n'est régulé sur le web, c'est pour cette raison que vous avez besoin d'un mentor qui cherche sincèrement à vous aidez à atteindre vos objectifs. Et c'est exactement ce que nous voulons vous transmettre en seulement quelques mois de suivis. Peu importe votre domaine d'activité.
          </p>
        </div>

        <Sidebar />
      </div>
    </div>
  );
};

export default Training;
